import type { ScreenSchema } from './types';
const builderSchema: ScreenSchema = {
  template: 'builder',
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' }
      ]
    }
  }
};
export default builderSchema;
